module.exports = __webpack_public_path__ + "img/cpany19.5366dca7.png";